import React, { useState } from "react";

export const Navigation = ({ theme, onToggleTheme }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle${open ? "" : " collapsed"}`}
            onClick={() => setOpen((v) => !v)}
            aria-controls="bs-example-navbar-collapse-1"
            aria-expanded={open}
            aria-label="Toggle navigation"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="menu-label">{open ? "Close" : "Menu"}</span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top" style={{display: "flex", alignItems: "center", textDecoration: "none"}}>
            <img
              src="/logo.png"
              alt="Maitri Tech Logo"
              style={{ height: "40px", marginRight: "10px" }}
            />
            <div style={{
              display: "flex",
              flexDirection: "column",
              lineHeight: "1",
              fontFamily: "'Arial', 'Helvetica', sans-serif",
              fontWeight: "bold"
            }}>
              <span className="brand-name">MAITRI</span>
              <span className="brand-name">TECH</span>
            </div>
          </a>
        </div>

        <div
          className={`collapse navbar-collapse${open ? " in" : ""}`}
          onClick={(e) => {
            if (e.target.closest("a")) close();
          }}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li> */}
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            {/* <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
            <li className="nav-cta-item">
              <a href="#contact" className="page-scroll nav-cta">
                Start a project <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </a>
            </li>
            <li className="theme-toggle-item">
              <button
                type="button"
                className="theme-toggle"
                onClick={onToggleTheme}
                aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
                title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
              >
                <i className={`fa ${theme === "dark" ? "fa-sun-o" : "fa-moon-o"}`} aria-hidden="true"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
